module.exports = __webpack_public_path__ + "a4b167103021785b1e6d6af868c51f39.gif";